import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { WorkerEducationEmbedded } from '@restworld/utility-types';
import { PresentationCard } from '@restworld/ui-ds';
import { AcademicCapIcon, UserAcademicCapIcon, toDateFormat } from '@restworld/utils-common';

export const TrainingSectionItem = ({
  workerTraining,
}: {
  workerTraining: WorkerEducationEmbedded;
  workerTrainingIndex: number;
}) => {
  const { t } = useTranslation();
  const errorMessage = t('missing_info');
  const memoValues = useMemo(() => {
    const title = workerTraining?.education_title_var.label;
    const issueDate = workerTraining?.issue_date ? toDateFormat(workerTraining?.issue_date) : undefined;
    return { title, issueDate };
  }, [workerTraining?.education_title_var.label, workerTraining?.issue_date]);
  const { title, issueDate } = memoValues;

  return (
    <div tw="flex flex-col w-full">
      <div tw="flex lg:flex-row flex-col lg:gap-8 gap-4 w-full">
        <div tw="flex flex-col lg:w-1/2 w-full items-start justify-start gap-4">
          <PresentationCard
            label={t('common:qualification_1')}
            header={title || errorMessage}
            icon={<AcademicCapIcon />}
            isError={!title}
          />
        </div>
        <div tw="flex flex-col lg:w-1/2 w-full items-start justify-start gap-4">
          <PresentationCard
            label={t('common:release_date')}
            header={issueDate || errorMessage}
            isError={!issueDate}
            icon={<UserAcademicCapIcon />}
          />
        </div>
      </div>
    </div>
  );
};
